module.exports = __webpack_public_path__ + "static/mobile-meetings-creative-9ee0d2ce0403b18f0595c72f4489acd8.png";